module.exports = {"130435100":"曲周镇","130435101":"安寨镇","130435102":"侯村镇","130435103":"河南疃镇","130435104":"第四疃镇","130435105":"白寨镇","130435200":"槐桥乡","130435201":"南里岳乡","130435203":"大河道乡","130435204":"依庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130435.json
// module id = 128
// module chunks = 0